/* eslint-disable no-template-curly-in-string */
import * as yup from "yup";

yup.setLocale({
  mixed: {
    required: "This field is required."
  },
  string: {
    min: "Please enter at least ${min} characters.",
    max: "Please enter no more than ${max} characters."
  },
  number: {
    // min: "Valor inválido (deve ser maior ou igual a ${min})",
    // max: "Valor inválido (deve ser menor ou igual a ${max})"
  }
});

export default yup;
